<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="cols"
        :form-context="formContext"
        icon="inticon-comment"
        title="Kommunikation"
        @save="saveFirmRemarks">
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Kommunikation RA"
                property="remarksRequestLawyer"
                type="autogrowtextarea"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Kommunikation Service"
                property="remarksCommunicationService"
                type="autogrowtextarea"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Kommunikation Buchhaltung"
                property="remarksAccounting"
                type="autogrowtextarea"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Kommunikation Geschädigter"
                property="remarksAdversary"
                type="autogrowtextarea"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Partnerversicherung"
                property="remarksPartnerInsurance"
                type="autogrowtextarea"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Sonstiges"
                property="remarksOther"
                type="autogrowtextarea"/>
        </b-row>
    </csp-desktop-info-card>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

    const container = Container.getInstance();
    const firmRepository = container.getDesktopFirmRepository();

    export default {
        name: 'FirmRemarks',
        mixins: [FormDataMixin],
        props: {
            cols: {
                type: Number,
                default: 12,
            },
        },
        computed: {
            firmId() {
                return this.$route.params.firmId;
            },
        },
        methods: {
            saveFirmRemarks(formContext) {
                const saveFunction = (objectId, postData) => {
                    return firmRepository.saveFirmRemarks(objectId, postData);
                };
                this.saveFormData(formContext, saveFunction);
            },
        },
    }
</script>
